import React from 'react';
import { isEmpty, take } from 'lodash';
import { formatTimeHuman } from '../../utils/time';
import { dutyTransactionPath, DutyRequestIcon } from '../../utils/dutyTransactions';
import TransactionStateLabel from '../schedule/exchanges/TransactionStateLabel';
import GroupName from '../general/GroupName';

const DutyTransactionLink = ({ dt }) => (
  <a href={dutyTransactionPath(dt)} target="_blank" rel="noreferrer">
    <i className="fa fa-eye" />
  </a>
);

const OverlappingDutyTransactionRow = ({ dt, multiGroup, showResponses }) => {
  if (isEmpty(dt) || dt.transient) return null;

  if (dt.transient || !dt.duty_exchange_intervals) return [];

  // To prevent the table form displaying too many items and occupy
  // a lot of space, we will only show 5 of the overlapping requests
  // and a label showing how many more there are
  const sample = take(dt.duty_exchange_intervals, 5);
  const tailSize = dt.duty_exchange_intervals.length - sample.length;

  const nicknames = sample.map(interval => interval.user?.nickname);

  let responders = nicknames.join(', ');

  if (tailSize > 0) {
    responders = `${responders} + ${I18n.t('n_others', { count: tailSize })}`;
  }

  return (
    <tr>
      <td>
        <DutyRequestIcon type={dt.type} />
      </td>
      <td>{formatTimeHuman(dt.created_at)}</td>
      <td>{formatTimeHuman(dt.start_time)}</td>
      <td>{formatTimeHuman(dt.end_time)}</td>
      {multiGroup && <td>{dt.group && dt.station && <GroupName group={dt.group} parentGroup={dt.station} />}</td>}
      {showResponses && <td>{responders}</td>}
      <td>
        <TransactionStateLabel transactionState={dt.state} />
      </td>

      <td>
        <DutyTransactionLink dt={dt} />
      </td>
    </tr>
  );
};

export default OverlappingDutyTransactionRow;
